<template>
  <div>
    <el-divider>表格</el-divider>
    <div label="模版">
      <el-input type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入内容"
                v-model="template">
      </el-input>
      <el-button type="text"
                 @click="handleTemplateByString">通过模版导入</el-button>
      <el-button type="text"
                 @click="handleTemplateByApi">通过接口导入</el-button>
    </div>
    <div class="edit_container">
        <draggable v-model="config.custom" class="prop_list">

            <template v-for="(domain, index) in config.custom">
              <el-tag :key="index" @click="editDomain(domain)"
              :type="currentDomain==domain?'danger':''"

                      @close="removeDomain(domain)"
                      closable>
                {{domain.label}}
              </el-tag>
            </template>
             <div class="new-form-btn"
             @click="addDomain">
          <i class="el-icon-plus"></i>
          <span>新增</span>
        </div>
        </draggable>
      <el-form :model="config"
               ref="config"
               size="small"
               status-icon
               label-width="80px">
            <template v-for="(domain, index) in config.custom">
              <el-card class="box-card" v-show="currentDomain==domain"
                       shadow="hover"
                       :key="index">
                <el-form-item label="类型"
                              slot="header">
                  <el-radio-group v-model="domain.type"
                                  @change="(e)=>handleType(e,domain)">
                    <el-radio v-for="item in componentsTypes"
                              :key="item.value"
                              :label="item.value">{{item.label}}</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="名称"
                                  :prop="'custom.' + index + '.label'"
                                  :rules="{required: true, message: '名称不能为空', trigger: 'blur'}">
                      <el-input v-model.trim="domain.label"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item label="属性"
                                  maxlength="32"
                                  :prop="'custom.' + index + '.prop'"
                                  :rules="{required: true, message: '接口不能为空', trigger: 'blur'}">
                      <el-input v-model.trim="domain.prop"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <template v-if="domain.type=='TTemp'">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="模版"
                                    maxlength="32"
                                    :prop="'custom.' + index + '.map'">
                        <el-input v-model.trim="domain.map"
                                  type="textarea"
                                  autosize></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
                <template v-if="domain.type=='TMap'">
                  <el-row>
                    <el-col :span="12">
                      <el-form-item label="类型"
                                    maxlength="32"
                                    :prop="'custom.' + index + '.mulitType'">
                        <el-select v-model="domain.mulitType"
                                   filterable>
                          <el-option v-for="item in mulitTypes"
                                     :key="item.value"
                                     :label="item.label"
                                     :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="参数"
                                    maxlength="32"
                                    :prop="'custom.' + index + '.map'">
                        <el-input v-model.trim="domain.map"
                                  type="textarea"
                                  autosize></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
<el-row>
                    <el-col :span="12">
                      <el-form-item label="valueKey"
                                    :prop="'custom.' + index + '.valueKey'">
                        <el-input v-model.trim="domain.valueKey"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="labelKey"
                                    :prop="'custom.' + index + '.labelKey'">
                        <el-input v-model.trim="domain.labelKey"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </template>
              </el-card>
            </template>
       
      </el-form>
    </div>
  </div>
</template>

<script>
const files = require.context(
  "../q_componts",
  false,
  /\bt_(?!router|add).*\.vue/
);
const allComponentType = [];
files.keys().forEach(element => {
  const component = files(element).default;
  allComponentType.push({
    label: component.cName,
    value: component.name,
    defaultProp: component.defaultProp
  });
});
import _ from "lodash";
import genApi, { get as getApi } from "@/quick/gen-api";
import base_add from './base_add.js'
export default {
  name: "TAdd",
  mixins:[base_add],
  data() {
    return {
      // dialogVisible:false
      componentsTypes: [...allComponentType, { label: "模版", value: "TTemp" }],
      mulitTypes: [
        {
          value: "url",
          label: "接口"
        },
        {
          value: "custom",
          label: "自定义"
        },
        {
          value: "local",
          label: "现有列表"
        }
      ],
      template: ""
    };
  },
  methods: {
    addDomain(domain = {}) {
      this.config.custom.push({
        prop: "default",
        label: "default",
        type: "TWord",
        map: "",
        valueKey: "value",
        labelKey: "label",
        mulitType: "url",
        ...domain
      });
    },
    handleType(value, domain) {
      console.log("handleType -> value", value);
      const type = this.componentsTypes.find(type => {
        return type.value == value;
      });
      if (type.defaultProp) {
        domain.prop = type.defaultProp;
        domain.label = type.label;
      }
    },
    looseJsonParse(obj) {
      return Function('"use strict";return (' + obj + ")")();
    },
    async handleTemplateByApi() {
      try {
        const resp = await getApi(this.template)();
        console.log("handleTemplateByApi -> resp", resp);
        if (resp && resp.data.tabledata) {
          if (resp.data.tabledata.length == 0) {
            this.$notify.error({
              title: "接口错误",
              message: "接口tabledata为空"
            });
          } else {
            this.handleTemplate(resp.data.tabledata[0]);
          }
        } else {
          this.$notify.error({
            title: "接口错误",
            message: "接口不存在tabledata"
          });
        }
        // const result = this.looseJsonParse(this.template)
      } catch (error) {
        this.$notify.error({
          title: "接口错误",
          message: error
        });
      }
    },
    handleTemplateByString() {
      try {
        const result = this.looseJsonParse(this.template);
        this.handleTemplate(result);
      } catch (error) {
        this.$notify.error({
          title: "模版错误",
          message: error
        });
      }
    },
    handleTemplate(obj) {
      Object.keys(obj).forEach(key => {
        if (key == "id") {
          return true;
        }
        let domain = this.config.custom.find(cfg => {
          return cfg.prop == key;
        });
        if (domain) {
        } else if (this[`handleTemplate_${key}`] != undefined) {
          this.addDomain(this[`handleTemplate_${key}`](key));
        } else {
          this.addDomain(this.handleTemplate_default(key));
        }
      });
    },
    handleTemplate_default(key) {
      if (key.search("img|image") >= 0) {
        return {
          prop: key,
          type: "TImg",
          label: "图片"
        };
      }
      return {
        prop: key,
        type: "TWord"
      };
    },
    handleTemplate_update_time(key) {
      return {
        prop: key,
        type: "TUpdateTime",
        label: "更新时间"
      };
    },
    handleTemplate_sort(key) {
      return {
        prop: key,
        type: "TDefaultSort",
        label: "排序"
      };
    },
    handleTemplate_status(key) {
      return {
        prop: key,
        type: "TDefaultStatus",
        label: "开关"
      };
    },
    handleTemplate_name(key) {
      return {
        prop: key,
        type: "TWord",
        label: "名称"
      };
    },
    handleTemplate_create_time(key) {
      return {
        prop: key,
        type: "TWord",
        label: "创建时间"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
@import './add.scss';


</style>